import { render, staticRenderFns } from "./ResourceSearchComp.vue?vue&type=template&id=24e82d88&"
import script from "./ResourceSearchComp.vue?vue&type=script&lang=js&"
export * from "./ResourceSearchComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports